var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import dayjs from 'dayjs';
import { Vue } from 'vue-property-decorator';
import { AiReportEditMutationTypes } from '@/types/ai-report-edit';
import reportApiClient from '@/plugins/apis/report-api-client';
export var state = function () { return ({
    project_title: '',
    address: '',
    construction_start_date: null,
    construction_end_date: null,
    cost: null,
    description: '',
    report_fields: []
}); };
export var getters = {
    projectTitle: function (state) {
        return state.project_title;
    },
    address: function (state) {
        return state.address;
    },
    constructionStartDate: function (state) {
        return state.construction_start_date;
    },
    constructionEndDate: function (state) {
        return state.construction_end_date;
    },
    cost: function (state) {
        return state.cost;
    },
    description: function (state) {
        return state.description;
    },
    reportFields: function (state) {
        return state.report_fields;
    }
};
export var mutations = (_a = {},
    _a[AiReportEditMutationTypes.INIT_STATE] = function (state, payload) {
        Object.assign(state, payload);
    },
    _a[AiReportEditMutationTypes.FETCH_REPORT] = function (state, payload) {
        if (payload.report_information) {
            state.project_title = payload.report_information.project_title;
            state.address = payload.report_information.address;
            var cost = Number.parseInt(payload.report_information.cost);
            if (Number.isInteger(cost)) {
                state.cost = cost;
            }
            state.description = payload.report_information.description;
            state.construction_start_date = dayjs(payload.report_information.start_date).toDate();
            state.construction_end_date = dayjs(payload.report_information.end_date).toDate();
            state.report_fields = payload.report_fields || [];
        }
    },
    _a[AiReportEditMutationTypes.SET_PROJECT_TITLE] = function (state, payload) {
        state.project_title = payload;
    },
    _a[AiReportEditMutationTypes.SET_ADDRESS] = function (state, payload) {
        state.address = payload;
    },
    _a[AiReportEditMutationTypes.SET_CONSTRUCTION_START_DATE] = function (state, payload) {
        state.construction_start_date = payload;
    },
    _a[AiReportEditMutationTypes.SET_CONSTRUCTION_END_DATE] = function (state, payload) {
        state.construction_end_date = payload;
    },
    _a[AiReportEditMutationTypes.SET_COST] = function (state, payload) {
        state.cost = payload;
    },
    _a[AiReportEditMutationTypes.SET_DESCRIPTION] = function (state, payload) {
        state.description = payload;
    },
    _a[AiReportEditMutationTypes.UPDATE_FIELD] = function (state, payload) {
        var index = state.report_fields.findIndex(function (field) { return field.id === payload.id; });
        if (index >= 0) {
            Vue.set(state.report_fields, index, payload);
        }
    },
    _a);
export var actions = {
    initState: function (_a) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.INIT_STATE, state());
    },
    fetchReport: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, reportApiClient.fetchReport(payload, 'ai')];
                    case 1:
                        response = _b.sent();
                        commit(AiReportEditMutationTypes.FETCH_REPORT, response.data.report);
                        return [2 /*return*/];
                }
            });
        });
    },
    setProjectTitle: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.SET_PROJECT_TITLE, payload);
    },
    setAddress: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.SET_ADDRESS, payload);
    },
    setConstructionStartDate: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.SET_CONSTRUCTION_START_DATE, payload);
    },
    setConstructionEndDate: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.SET_CONSTRUCTION_END_DATE, payload);
    },
    setCost: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.SET_COST, payload);
    },
    setDescription: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.SET_DESCRIPTION, payload);
    },
    updateField: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.UPDATE_FIELD, payload);
    }
};
